import React from "react";
import bodyHelperTypes from "../../../utils/BodyHelperTypes";


const facilitesHome_Content = [

    {
        format: bodyHelperTypes.title,
        order: 10,
        content: "Overview"
    },
    {
        format: bodyHelperTypes.paragraphs,
        order: 20,
        content: [
            <>
                <p>
                    The department owns several inpatient facilities that provide psychiatric, rehabilitative and nursing care services to its clients.
                </p>
                <p>
                    In addition, the department contracts with a private provider, Appalachian Regional Healthcare in Hazard, to provide up to 100 inpatient psychiatric beds for citizens of 21 eastern Kentucky counties as outlined in 908 KAR 2:040.
                </p>
                <p>
                    For information on a specific facility, see the list below.
                </p>

                <h1 id='Psychiatric Hospitals'>Psychiatric Hospitals</h1>

                <p>
                    These programs provide acute, inpatient psychiatric care for adults who are mentally ill. Many patients are referred through the CMHCs when it has been determined that community services/facilities are not appropriate.
                </p>
                <div class="row ">
                    <div class="col">
                        <p>
                            <b><a href="mailto:bmyers@arh.org">Brian Myers, System Director of Behavioral Health</a></b><br />

                            ARH Psychiatric Center - Hazard<br />
                            <b><a href="mailto:thall8@arh.org ">Tiffany Hall, System Director</a></b><br />
                            102 Medical Center Drive <br />
                            Hazard, Ky 41701, (606-439-6712) <br />
                            <b>Hotline:</b> (606) 439-6833 <br />
                            <b>Fax:</b>  (606) 439-67010 <br />
                            <a href='https://www.arh.org/behavioral-health'>https://www.arh.org/behavioral-health <br /></a>
                        </p>
                    </div>
                    <div class="col">
                        <p>
                            <b><a href="mailto:Matt.Mooring@ky.gov">Matt Mooring, Director</a></b><br />
                            Central State Hospital<br />
                            10510 LaGrange Road <br />
                            Louisville, KY 40223-1228<br />
                            <b><a href="mailto:Laurenjo.doyle@ky.gov">Lauren Doyle</a>: (502-253-7061)</b><br />
                            <b>Hotline:</b> (502) 253-7107<br />
                            <b>Fax:</b>  (502) 253-7049 <br />
                        </p>
                    </div>


                </div>


                <div class="row ">
                    <div class="col">
                        <p>
                            <b><a href="mailto:lindsey.jasinski@uky.edu">Lindsey Jasinski</a></b><br />
                            Eastern State Hospital<br />
                            1350 Bull Lea Road <br />
                            Lexington, KY 40511 <br />
                            <b>Mindy Holland:</b> (859) 246-8025 <br />
                            <b>Lexi Bentley:</b>  (859) 246-8028 <br />
                            <b>Fax:</b>  (859) 246-8032 <br />
                            <b>Lexi Bentley</b> <a href="Lexi.Bentley@uky.edu">Lexi.Bentley@uky.edu, (859)246-8000</a><br/>
                            <a href='http://ukhealthcare.uky.edu/eastern-state-hospital/'>http://ukhealthcare.uky.edu/<br />eastern-state-hospital/</a>
                        </p>
                    </div>
                    <div class="col">
                        <p>
                            <b><a href="mailto:Rebeccaj.frost@ky.gov">Rebecca Frost, Director</a></b><br />
                            Western State Hospital<br />
                      
                            2400 Russellville Road <br />
                            P.O. Box 2220 <br />
                            (270) 889-6025<br/>
                            <a href="Amber.siegmund@ky.gov">Amber Siegmund</a><br/>
                            (270) 889-2882
                            Hopkinsville, KY 42241-2200 <br />
                            <b>Hotline:</b> (270) 889-0001 <br />
                            <b>Fax:</b>  (270) 886-4487 <br />
                            <a href='http://westernstatehospital.ky.gov/'>http://westernstatehospital.ky.gov/</a>
                        </p>
                    </div>
                </div>


                <h1 id='Intermediate Care Facilities for Individuals With Intellectual Disabilities (ICF/IID)'>Intermediate Care Facilities for Individuals With Intellectual Disabilities (ICF/IID)</h1>

                <p>

                    These programs are designed to provide comprehensive and individualized health care, training and habilitation services to individuals to promote their functional skills and independence.
                </p>



                <div class="row ">
                    <div class="col">
                        <p>
                            <b><a href="mailto:Kelly.Mangum@newvista.org">Kelly T. Mangum, Director</a></b><br />
                            Bingham Gardens/ICF <br />
                        
                            4407 Louise Underwood Way <br />
                            Louisville, KY 40216<br />
                            <b>Phone:</b> (502) 361-2301 <br />
                            <b><a href="mailto:Kelly.Mangum@newvista.org">Robert Daughtry</a></b><br />
                            <b>Fax:</b>  (502) 366-0367 <br />
                            <a href='https://hazelwood.org/'>https://hazelwood.org/</a>

                        </p>
                    </div>
                    <div class="col">
                        <p>
                            <b><a href="mailto:Kelly.Mangum@newvista.org">Kelly T. Mangum, Director</a></b><br />
                            Hazelwood Center/ICF<br />
                            1800 Old Bluegrass Center <br />
                            P.O. Box 14506 <br />
                            Louisville, KY 40215-1130<br />
                            (502) 361-2301 EXT. 2200<br/>
                            <b><a href="mailto:Gerri.franklin@newvista.org">Gerri Franklin</a></b><br />
                            <b>Phone:</b> (502) 361-2301 <br />
                            <b>Fax:</b>  (502) 366-0367 <br />
                            <b>Del Maria:</b> (502) 499-7203<br/>
                            <b>Meadows:</b> (502) 538-8189<br/>
                            <b>Windsong:</b> (502) 241-2461<br/>
                            <a href='https://hazelwood.org/'>https://hazelwood.org/</a>
                        </p>
                    </div>
                </div>

                <div class="row ">
                    <div class="col">
                        <p>
                            <b><a href="mailto:Darla.Crabtree@newvista.org ">Darla Crabtree, Director</a></b><br />
                            Oakwood ICF<br />
                            
                            2441 US 27 South HWY 27<br />
                            Somerset, KY 42501-2935<br />
                            <b><a href="mailto:ginger.todd@newvista.org">Ginger Todd</a></b><br />
                            <b>Phone:</b> (606) 677-4068 EXT. 1041 <br />
                            <b>Hotline:</b> (606) 677-4078 <br />
                            <b>Fax:</b>  (606) 677-4148 <br />
                            <a href='https://oakwoodky.org/'>https://oakwoodky.org/</a>


                        </p>
                    </div>
                    <div class="col">
                        <p>
                            <b><a href="mailto:Kellie.stricker@ky.gov">Kellie Stricker, Executive Director</a></b><br />
                            <b><a href="mailto:crystal.franklin@ky.gov">Crystal Franklin, Asst Executive Director</a></b><br />
                            Outwood ICF<br />
                            23524 Dawson Springs Road<br />
                            Dawson Springs, KY 42408-0524 <br />
                            <b>Phone:</b> (270) 797-3771 EXT. 106 <br />
                            <b>Phone:</b> (270) 797-3771 EXT. 179 <br />
                            <b>Phone Alt:</b>  (270) 797-3592 <br />
                            <a href='https://rescarecommunityliving.com/location/rescare-community-living-outwood-dawson-springs-ky/'>https://rescarecommunityliving.com/location/rescare-community-living-outwood-dawson-springs-ky/</a>
                        </p>
                    </div>
                </div>


                <h1 id='Nursing Facilities or Intermediate Care Facilities (ICFs)'>Nursing Facilities or Intermediate Care Facilities (ICFs)</h1>

                <p>

                    These programs provide long-term medical care for mentally ill persons who also require treatment or supervision of the mental illness. Criteria for admission is inpatient status in other state-operated facilities.

                </p>


                <div class="row ">
                    <div class="col">
                        <p>
                            <b><a href="mailto:Amanda.allen@ky.gov ">Amanda Allen, Director</a></b><br />
                            Glasgow SNF<br />
                            207 State Avenue<br />
                            P.O. Box 189<br />
                            Glasgow, KY 42141<br />
                            <b>Phone:</b> (270) 659-4708 Direct# <br />
                            <b>Phone:</b> (270) 659-4700 Main# <br />
                            <b>Fax:</b>  (270) 651-1726 <br />
                            <a href='http://glasgowsnf.ky.gov/'>http://glasgowsnf.ky.gov/</a>

                        </p>
                    </div>
                    <div class="col">
                        <p>
                            <b><a href="mailto:Rebeccaj.frost@ky.gov">Rebecca Frost, Director</a></b><br />
                            Western State Nursing Facility<br />
                            2400 Russellville Road<br />
                            Hopkinsville, KY 42241 <br />
                            (270) 889-2990<br/>
                            <b><a href="mailto:Regina.Hampton@ky.gov">Regina Hampton</a></b><br />
                            <b>Phone:</b> (270) 889-2982 <br />
                            <b>Fax:</b>  (270) 886-7910 <br />
                            <a href='http://westernstatehospital.ky.gov/'>http://westernstatehospital.ky.gov/</a>
                        </p>
                    </div>
                </div>

                <h1 id='Intermediate Care Facility Specialty Clinics'>Intermediate Care Facility Specialty Clinics</h1>

                <p>

                    The specialty clinics provide evidence-based, holistic health care for people with intellectual and other developmental disabilities living in the facility or community.


                </p>


                <div class="row ">
                    <div class="col">
                        <p>
                            <b><a href="mailto:Darla.Crabtree@newvista.org">Darla Crabtree, Director</a></b><br />
                            Oakwood/ICF<br />
                            <b>Adam Wright, Director</b><br />
                            2441 S. Highway 27<br />
                            Somerset, KY 42501<br />
                            (607) 677-4078 EXT. 1041<br/>
                            <b><a href="mailto:ginger.todd@newvista.org">Ginger Todd</a></b><br />
                            <b>Hotline:</b> (606) 677-4078 <br />
                            <b>Fax:</b>  (606) 677-4148 <br />
                            <a href='http://www.oakwoodky.org/specialty-medical-clinic/getting-started'>http://www.oakwoodky.org/<br />
                                specialty-medical-clinic/getting-started</a>

                        </p>
                    </div>
                    <div class="col">
                        <p>
                            <b><a href="lynzeecornell@admed.us">Lynzee Cornell, CEO</a></b><br />
                            Lee Specialty Clinic<br />
                            4501 Louise Underwood Way<br />
                            Louisville, KY 40216 <br />
                            <b>Phone:</b> (502) 368-2348 <br />
                            <a href='http://www.leespecialtyclinic.com'>http://www.leespecialtyclinic.com</a>
                        </p>
                    </div>
                </div>


                <div class="row ">
                    <div class="col">
                        <p>
                            <b><a href="Kelly.Mangum@newvista.org">Kelly T. Mangum, Director</a></b><br/>
                            Hazelwood Center Specialty Intermediate Care Clinic<br />
                            Louisville, KY 40215-1130<br />
                            (502) 361-2301 EXT 2200<br/>
                            <b><a href="Gerri.franklin@newvista.org">Gerri Franklin</a></b><br />
                            <b>Hotline:</b> 1 (800) 928-8000 <br />
                            <b>Fax:</b>  (502) 366-0367 <br />
                            <b>Del Maria:(502) 538-7203</b> <br/>
                            <b>Meadows:</b> (502) 538-8189<br/>
                            <b>WindSong:</b> (502) 241-2461<br/>
                            <a href='https://hazelwood.org/'>https://hazelwood.org/</a>
                        </p>
                    </div>
                </div>


                <h1 id='Forensic Psychiatric Hospital'>Forensic Psychiatric Hospital</h1>

                <p>

                    Kentucky Correctional Psychiatric Center (KCPC) is a licensed psychiatric hospital that conducts forensic competency evaluations, competency restoration, and criminal responsibility evaluations for pre-trial patients. The facility also provides inpatient treatment for individuals who have been adjudicated incompetent to stand trial and are held on a civil commitment order. All patients at KCPC are court-ordered under KRS 504.080, KRS 504.110, or KRS 202C. KCPC serves all 120 counties and is located in a secure facility on the grounds of Luther Luckett Correctional Complex in Lagrange, Kentucky.
                </p>



                <div class="row ">
                    <div class="col">
                        <p>

                            <b><a href="Koleen.Slusher@ky.gov">Koleen Slusher, Director</a></b><br />
                            Kentucky Correctional Psychiatric Center<br />
                            1612 Dawkins Road<br />
                            P.O. Box 67<br />
                            LaGrange, KY 40031 <br />
                            (502) 222-7161<br/>
                            <b><a href="janet.soehner@ky.gov">Janet Soehner EXT. 5230</a></b><br/>
                            <b>Phone:</b> (502) 222-0067 <br />
                            <b>Fax:</b>  (502) 222-7798 <br />
                        </p>
                    </div>
                </div>

            </>
        ]
    },
];

export default facilitesHome_Content;